import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { observer, inject } from 'mobx-react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import { formatDateToDate, formatNumber } from '@atheneum/api/dist/lib'
import '../Sidebar.sass'

import ContractSidebarStore from './ContractSidebar.store'

import RenderField from '../Components/RenderField'

class ClientContact extends Component {
  static propTypes = {
    id: PropTypes.number,
    sidebarStore: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired
  }

  constructor (props) {
    const { staticData, id } = props

    super(props)

    extendObservable(this, {
      contractSidebarStore: new ContractSidebarStore(staticData)
    })

    this.loadContract(id)
  }

  loadContract = contractId => {
    this.contractSidebarStore.get(contractId)
  }

  handleContractClick = () => {
    const { sidebarStore } = this.props
    sidebarStore.closeSidebar()
  }

  render () {
    const { sidebarStore } = this.props
    const { contractSidebarStore } = this
    if (!contractSidebarStore.contract) return null
    const contract = contractSidebarStore.contract
    const staticData = contractSidebarStore.staticData
    const { CONTRACT_TYPES } = staticData.CONST
    return (
      <div>
        <h1 onClick={this.handleContractClick}>
          <NavLink
            to={`/client-search/parent-account/${
              contract.parentAccountId
            }/contracts/${contract.id}`}
          >
            {contract.contractReference}
          </NavLink>
          {renderStatus(contract.contractStatusId, staticData)}
        </h1>
        <NavLink to={`/parent-account/${contract.parentAccountId}`}>
          {contract.parentAccount.parentAccountName}
        </NavLink>

        <RenderField
          label='Contract type'
          dataType='contractTypes'
          value={contract.contractTypeId}
          staticData={staticData}
        />

        <RenderField
          label='Coverage'
          dataType='contractCoverages'
          value={contract.contractCoverageId}
          staticData={staticData}
          renderItems={renderCoverageItems(contract, sidebarStore, staticData)}
        />

        <RenderField
          label='Contract type details'
          dataType='contractTypeDetails'
          value={contract.contractTypeDetailsId}
          staticData={staticData}
        />

        <RenderField
          label='BD contact'
          value={get(contract, 'employeeContact.fullName')}
          staticData={staticData}
        />

        {contract.linkedContracts.length ? (
          <div>
            <h2>Linked Contracts</h2>
            <RenderLinkedContracts contract={contract} />
          </div>
        ) : null}

        {contract.contractTypeId === CONTRACT_TYPES.PAYG ? (
          <div>
            <RenderField
              label='Start-End date'
              html={formatDateToDate(contract.startDate, contract.endDate)}
              staticData={staticData}
            />
            <RenderField
              label='Price range'
              html={formatPriceRange(contract, staticData)}
              staticData={staticData}
            />
          </div>
        ) : (
          <div>
            <RenderField
              label='Credit amount'
              html={formatNumber(contract.creditAmount)}
              staticData={staticData}
            />
            <RenderField
              label='Credit value'
              html={formatCreditValue(contract, staticData)}
              staticData={staticData}
            />
          </div>
        )}

        <RenderField
          label='Total value'
          html={formatTotalValue(contract, staticData)}
          staticData={staticData}
        />

        <RenderField
          label='Contract balance'
          html={formatBalance(contract, staticData)}
          staticData={staticData}
        />

        <RenderAccount contract={contract} staticData={staticData} />
        <RenderProject contract={contract} staticData={staticData} />

        <h2>Specific Conditions</h2>
        <RenderField
          html={contract.specialConditions}
          staticData={staticData}
        />

        <a href='/standard-conditions' target='_blank'>
          Standard conditions
        </a>

        <RenderField
          label='Additional comments'
          html={contract.additionalComment}
          staticData={staticData}
        />
      </div>
    )
  }
}

function renderCoverageItems (contract, sidebarStore, staticData) {
  let items = []
  const { GLOBAL } = staticData.CONST.CONTRACT_COVERAGES
  if (contract.contractCoverageId === GLOBAL) return
  if (contract.accounts.length) {
    items = contract.accounts
  }
  if (contract.projects.length) {
    items = contract.projects
  }
  return items.map(item => {
    let itemName
    let url
    if (item.companyName) {
      itemName = item.companyName
      url = `/account/${item.id}`
    }
    if (item.projectName) {
      itemName = item.projectName
      url = `/project/${item.id}`
    }
    return (
      <p
        key={item.id}
        className='sidebar-wrapper__content__link'
        onClick={() => sidebarStore.closeSidebar()}
      >
        <NavLink to={url}>{itemName}</NavLink>
      </p>
    )
  })
}

function RenderLinkedContracts ({ contract }) {
  return (
    <div className='group'>
      {contract.linkedContracts.map(linkedContract => {
        return (
          <NavLink
            to={`/client-search/parent-account/${
              linkedContract.parentAccountId
            }/contracts/${linkedContract.id}`}
            key={linkedContract.id}
          >
            {linkedContract.contractReference}
          </NavLink>
        )
      })}
    </div>
  )
}
RenderLinkedContracts.propTypes = {
  contract: PropTypes.object
}

function renderStatus (contractStatusId, staticData) {
  const status = staticData.getDataFromArray(
    contractStatusId,
    'contractStatuses'
  )
  return <div className='client-status'>{status}</div>
}

function RenderAccount ({ contract, staticData }) {
  if (
    contract.contractCoverageId !==
    staticData.CONST.CONTRACT_COVERAGES.SPECIFIC_ACCOUNTS
  ) {
    return null
  }
  return (
    <RenderField
      label='Account'
      value={contract.account}
      staticData={staticData}
    />
  )
}
RenderAccount.propTypes = {
  staticData: PropTypes.object,
  contract: PropTypes.object.isRequired
}

function RenderProject ({ contract, staticData }) {
  if (
    contract.contractCoverageId !==
    staticData.CONST.CONTRACT_COVERAGES.SPECIFIC_PROJECTS
  ) {
    return null
  }

  return (
    <RenderField
      label='Project'
      value={contract.project}
      staticData={staticData}
    />
  )
}
RenderProject.propTypes = {
  staticData: PropTypes.object,
  contract: PropTypes.object.isRequired
}

function formatPriceRange (contract, staticData) {
  const { currencies } = staticData.names
  const { CONTRACT_TYPES } = staticData.CONST
  const currency = currencies[contract.currencyId]

  if (contract.contractTypeId !== CONTRACT_TYPES.PAYG) return '-'

  return `
  ${formatNumber(contract.rangeMin)}
   – ${formatNumber(contract.rangeMax)}
   ${currency}
  `
}

function formatTotalValue (contract, staticData) {
  const { currencies } = staticData.names
  const currency = currencies[contract.currencyId]
  if (contract.unlimited) return 'unlimited'
  return `${formatNumber(contract.calculatedValue)} ${currency}`
}

function formatCreditValue (contract, staticData) {
  const { currencies } = staticData.names
  const currency = currencies[contract.currencyId]

  return `${formatNumber(contract.creditValue)} ${currency}`
}

function formatBalance (contract, staticData) {
  const { currencies } = staticData.names
  const { CONTRACT_TYPES } = staticData.CONST
  const currency =
    contract.contractTypeId === CONTRACT_TYPES.PAYG
      ? currencies[contract.currencyId]
      : 'credits'
  if (contract.unlimited) return 'N/A'
  return `${formatNumber(contract.contractBalance)} ${currency}`
}

export default inject('sidebarStore', 'staticData')(observer(ClientContact))
